// @ts-nocheck

// With cart_type "page" the Add to Bag button gets the theme's `bttn--loading`
// spinner on submit, but the class is only cleared by a full-page navigation to
// /cart. When that navigation doesn't happen (the add resolves via ajax with no
// cart drawer to finish the flow), the spinner stays stuck. Clear it off the
// theme's documented cart events, with a timed fallback for the case where no
// event fires.
class CartButtonReset {
  constructor() {
    this.loadingClass = 'bttn--loading';
    this.fallbackMs = 2500;
    this.fallbackTimer = null;

    this.onCartSettled = this.onCartSettled.bind(this);
    document.addEventListener('flu:cart:item-added', this.onCartSettled);
    document.addEventListener('flu:cart:updated', this.onCartSettled);
    document.addEventListener('flu:cart:error', this.onCartSettled);

    this.setupFallback();
  }

  onCartSettled() {
    this.clearLoading();
  }

  clearLoading() {
    const buttons = document.querySelectorAll('[data-add-to-cart].' + this.loadingClass);
    buttons.forEach((button) => button.classList.remove(this.loadingClass));
  }

  // Safety net: if the loading class appears and no cart event clears it shortly
  // after (the stuck case), drop it ourselves. Harmless during a real page
  // navigation since the document unloads before the timer fires.
  setupFallback() {
    const form = document.querySelector('[data-product-form]');
    if (!form || typeof MutationObserver === 'undefined') return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const button = mutation.target;
        if (!button.classList || !button.classList.contains(this.loadingClass)) return;
        clearTimeout(this.fallbackTimer);
        this.fallbackTimer = setTimeout(() => this.clearLoading(), this.fallbackMs);
      });
    });

    form.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      observer.observe(button, { attributes: true, attributeFilter: ['class'] });
    });
  }
}

new CartButtonReset();
